import React, { useEffect, useState } from 'react';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Logo } from './Logo';
import { navLinks, site } from '../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-40 w-full bg-brand transition-shadow duration-200 ${scrolled ? 'shadow-[0_6px_24px_rgba(0,40,70,0.25)]' : ''}`} data-id="element-160" data-mp="31c8lknbizwr2">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-5 lg:px-8" data-id="element-161" data-mp="36cw8oxwmvtg0">
        <Logo inverted data-id="element-162" data-mp="3b8bmjpun5pcf" />

        <nav aria-label="Main" className="hidden items-center gap-6 lg:flex xl:gap-8" data-id="element-163" data-mp="3fb88nqje43l4">
          {navLinks.map(link => <a key={link.href} href={link.href} className="font-display text-lg font-semibold uppercase tracking-wide text-white/90 transition-colors duration-150 hover:text-white" data-id="element-164" data-mp="2wlm8ne6n24jw">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-5 lg:flex" data-id="element-165" data-mp="2hovg9ovdtt3s">
          <a href={site.phoneHref} className="hidden items-center gap-2 whitespace-nowrap font-display text-xl font-bold text-white xl:flex" data-id="element-166" data-mp="3fb2k2wjv3hf3">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-167" data-mp="3aelq3lpze8u3" />
            {site.phone}
          </a>
          <a href="#quote" className="whitespace-nowrap rounded-lg border-2 border-white bg-ink px-5 py-2.5 font-display text-lg font-bold text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-168" data-mp="30mfwy8nztldb">
            Get Your Free Quote
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} className="grid h-11 w-11 place-items-center rounded-lg text-white lg:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-169" data-mp="3t9aht6oq2mrb">
          {open ? <XIcon className="h-6 w-6" data-id="element-170" data-mp="1mml6tbty8zx0" /> : <MenuIcon className="h-6 w-6" data-id="element-171" data-mp="1mltce4c3988b" />}
        </button>
      </div>

      <AnimatePresence data-id="element-172" data-mp="18mk5jv9rvqh0">
        {open && <motion.nav id="mobile-nav" aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-white/15 bg-brand-dark px-5 pb-6 pt-2 lg:hidden" data-id="element-173" data-mp="18lijywv4rll1">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="block border-b border-white/10 py-3 font-display text-xl font-semibold uppercase text-white" data-id="element-174" data-mp="2t0uaogol62i2">
                {link.label}
              </a>)}
            <a href="#quote" onClick={() => setOpen(false)} className="mt-5 block rounded-lg bg-ink py-3 text-center font-display text-xl font-bold text-white" data-id="element-175" data-mp="w47r4hladljz">
              Get Your Free Quote
            </a>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}